export default {
  presets: {
    light: {
      backgroundPrimary: '#F9FBF4',
      backgroundSecondary: '#FFFFFF',
      backgroundCardPrimary: '#F7F9F2',
      backgroundCardSecondary: '#ECFDE6',
      backgroundElement: '#FFFFFF',
      backgroundBorder: '#D7E2C8',
      textPrimary: '#1F2937',
      textInverted: '#FFFFFF',
      primary: '#2e7d32',
      secondary: '#f9a825',
      success: '#228200',
      info: '#43a047',
      danger: '#E42222',
      warning: '#FFD43A',
      shadow: 'rgba(0, 0, 0, 0.1)',
      focus: '#2e7d32',
    },
    dark: {
      backgroundPrimary: '#0f1a0f',
      backgroundSecondary: '#1a2e1a',
      backgroundCardPrimary: '#112011',
      backgroundCardSecondary: '#0f1a0f',
      backgroundElement: '#2d4a2d',
      backgroundBorder: '#3d5c3d',
      textPrimary: '#f8fafc',
      textInverted: '#1f2937',
      primary: '#4caf50',
      secondary: '#fdd835',
      success: '#10b981',
      info: '#66bb6a',
      danger: '#ef4444',
      warning: '#f59e0b',
      shadow: 'rgba(0, 0, 0, 0.3)',
      focus: '#4caf50',
    },
  },
}
